// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".0b92ab7de9c9992ae9346c3bdd87c3ec.js";
};